import {Component} from '@angular/core';
import {DataStoreService} from 'app/shared/data-store/services/data-store.service';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css'],
})

export class ThankYouComponent {

  email: string;
  constructor(private dataStoreService: DataStoreService) {}

  ngOnInit() {
    this.email = this.dataStoreService.email; 
 }
}


